<template>
<div class="page full-height">

</div>
</template>

<script>
  import api from '../utils/api';
  import {Toast} from 'vant';
  import weChatUtil from '../utils/weChatUtil';
  import {TOKEN_KEY} from '../config/constant';
  export default {
    name: "auth",
    created() {
      const token = localStorage.getItem(TOKEN_KEY);
      if(token){
        this.$router.replace('/index');
        return;
      }
      console.log(this.$route.query.code);
      if (this.$route.query.code) {
        const url = '/login';
        const code = this.$route.query.code;

        api.post(url, {
          weChatCode : code,
          userType:1,
          loginType:2
        }).then(resp=>{
          if(resp.success){
            localStorage.setItem(TOKEN_KEY, resp.token);
            console.log("getToken", resp.token);
            let url = localStorage.getItem("beforeUrl");
            //跳转
            this.$router.replace(url);
          } else {
            this.$router.replace("/bind")
          }
        }).catch(() => {
          // setTimeout(() => {
          //   _this.$router.replace('/index');
          // }, 800)
        }).finally(() => {
          Toast.clear();
        })
      } else {
        const redirectUrl = weChatUtil.redirectAuth();
        window.location.href = redirectUrl;
      }
    },
    mounted(){
      Toast.loading({
        duration:0,
        mask: true,
        message: '授权中...'
      });
    },
  }
</script>


